import { openDialog } from 'src/services/jira';

import { trackEvent } from 'src/lib/analytics';
import { history } from 'src/lib/history';
import { localStorage } from 'src/lib/localStorage';

export const redirectToRuleChangeValidation = (initRuleValue = {}, newRuleValue = {}) => {
  localStorage.setItem('integration_jira_webhooks_validation_on_diff', {
    initRuleValue,
    newRuleValue
  });

  history.push(`/integration-jira-ui/settings/modal/rule/sync_webhooks`);
};

export const getNewAndOldRulesFromURL = () => {
  // URL is too short to bear all the rule. using localStorage to track last saved rule diff
  const { initRuleValue = {}, newRuleValue = {} } = localStorage.getItem('integration_jira_webhooks_validation_on_diff');
  return { initRuleValue, newRuleValue };
};

export const openWebhookValidationModal = () => {
  trackEvent('settings_rules', { label: 'check_webhooks' });
  openDialog(`/integration-jira-ui/settings/modal/rule/validate_webhooks`, {
    width: '40vw',
    minHeight: 500,
  });
};
